/*
    TEMPLATE FILE - DO NOT EDIT DIRECTLY
    This file is used by the build pipeline to generate environment-specific files.
    Placeholders are replaced with values from Azure Key Vault at build time.

    For local development, use environment.local.ts instead.
*/

// @ts-nocheck
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { EnvironmentBase, Environment, EnvironmentType } from './environment.base';

class TemplateEnvironment extends EnvironmentBase {
  public readonly name = 'staging';
  public readonly selfBaseUrl = 'https://staging.triggerbee.com';

  public readonly apiBaseUrls? = {
    gateway: 'https://staging-client-gw.triggerbee.com',
  };

  public readonly cookieNames = {
    peopleColumns: 'people_columns_staging',
    currentContext: 'current_context',
  };

  public readonly chargebeeSiteName = 'triggerbee-test';
  public readonly gtmId = 'GTM-KS9FQVM';
  public readonly appInsightsInstrumentationKey = '776cce3a-e318-458c-8eab-d28ee6b91c20';
  public readonly previewSiteUrl = 'https://staging-preview.triggerbee.com';
  public readonly trackerDomain = 'https://staging-tracker.triggerbee.com';
  public readonly blankTemplateId = 136;
  public readonly turnStileApiKey = '1x00000000000000000000AA';
  public readonly shopifyAppInstallUrl = 'https://admin.shopify.com/?organization_id=131027950&no_redirect=true&redirect=/oauth/redirect_from_developer_dashboard?client_id%3Dd5f46824607c5b77d8e1e4311729127e';
  public readonly defaultFromEmail = 'no-reply@development.triggermail.net';

  public readonly showDebug = false;

  constructor() {
    super(EnvironmentType.Staging);
  }
}

export const ENVIRONMENT: Environment = new TemplateEnvironment();
